import { render, staticRenderFns } from "./sales.vue?vue&type=template&id=b28d469a&scoped=true"
import script from "./sales.vue?vue&type=script&lang=ts&setup=true"
export * from "./sales.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28d469a",
  null
  
)

export default component.exports